// extracted by mini-css-extract-plugin
export default {"Overlay":"Modal_Overlay__yoxbg","Modal":"Modal_Modal__I1UYJ","Button":"Modal_Button__0Hwfy"};